/**
* @description 布局组件，用于管理整体页面布局
*/
<template>
  <div class="layout-container">
    <component :is="LayoutComponents[layoutType]" />
  </div>
</template>

<script setup>
  import { computed } from 'vue'
  import { useSettingStore } from '@/store/modules'

  defineOptions({
    name: 'Layout',
  })

  const settingStore = useSettingStore()

  /**
   * @description 获取当前布局类型
   */
  const layoutType = computed(() => settingStore.layoutType)

  /**
   * @description 布局组件映射表
   */
  const LayoutComponents = {
    defaultLayout: () => import('./layoutDefault/index.vue'),
  }
</script>

<style scoped lang="scss">
  .layout-container {
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
